/** iOS·iPadOS 브라우저(iPadOS 데스크톱 모드는 MacIntel + 터치) */
export const isIosBrowser = (nav: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints"> = navigator): boolean =>
  /iPhone|iPad|iPod/.test(nav.userAgent) || (nav.platform === "MacIntel" && nav.maxTouchPoints > 1);

/** Android 브라우저(태블릿 포함). */
export const isAndroidBrowser = (nav: Pick<Navigator, "userAgent"> = navigator): boolean => /Android/i.test(nav.userAgent);

export type WebDevice = "android" | "ios" | "desktop";

export const webDevice = (nav: Navigator = navigator): WebDevice => (isIosBrowser(nav) ? "ios" : isAndroidBrowser(nav) ? "android" : "desktop");
